import env from 'lib/env'

import {
  init,
  getKeyRemoteConfig
} from '@solides-front/jobs-frontend-utils/firebase-client'

init(env.firebase)

export { getKeyRemoteConfig }
